export function offscreenMenuToggle(button) {
    if (!button) return

    const openClass = 'is-visible';
    const bodyOpenClass = 'nav--is-open';
    const targetId = button.getAttribute('aria-controls');
    const menu = document.getElementById(targetId);

    if (!menu) return;

    function setMenuState(isOpen) {
        button.setAttribute('aria-expanded', String(isOpen));
        menu.classList.toggle(openClass, isOpen);
        document.body.classList.toggle(bodyOpenClass, isOpen);
        if (document.body.classList.contains('site-nav-visible')) {
            document.body.classList.remove('site-nav-visible');
        }
    }

    function handleToggleClick(e) {
        e.preventDefault();
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        setMenuState(!isExpanded);
    }

    button.addEventListener('click', handleToggleClick);
}